import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseCreateResource } from '../../utils/types';

type InstructionInput = TrpcInputs['createInstruction'];
type InstructionOutput = TrpcOutputs['createInstruction'];

type CreateInstructionMutate = MutateFunction<InstructionInput, InstructionOutput>;
type UseCreateInstruction = UseCreateResource<InstructionInput, InstructionOutput>;

export const useCreateInstruction = (): UseCreateInstruction => {
  const { mutateAsync: createAsync, isLoading, error } = trpc.createInstruction.useMutation();
  const create: CreateInstructionMutate = (args) => createAsync({ ...args } as InstructionInput);

  return {
    create,
    isLoading,
    error: error?.message,
  };
};
